/**
 *
 * MultiBarChart
 *
 */

import "./index.less"

import { HISTORICAL_ANALYSIS, RESULT_BY_TEAM } from "../../utils/constants"
import MultiDrillDown from "./MultiDrillDown"
import React from "react"
// import PropTypes from 'prop-types';
import { Switch } from "antd"
import { isModuleBySlug } from "../../utils/storage"
import { map } from "lodash"
import { loadTexts } from "../../utils/i18n"

/* eslint-disable react/prefer-stateless-function */
class MultiBarChart extends React.Component {
  intlmultiBarChart = loadTexts("reports_team_analysis_view").multiBarChart
  state = {
    subDimensions: [],
    questions: [],
    switchBars: false,
    dataParent: [],
    level: 0,
    prevDivisionParent: null,
    prevsDivisionParent: [],
    divisionParent: null,
  }

  componentDidUpdate = (prevProps) => {
    const { switchBars } = this.state

    if (this.props.clearState) {
      this.setState(
        {
          subDimensions: [],
          questions: [],
          dataParent: [],
        },
        () => this.props.setStateFrom("clearState", false)
      )
    }

    if (this.props.data) {
      if (!Array.isArray(this.props.data[0]) && switchBars) {
        this.setState({ switchBars: false })
      }

      if (Array.isArray(this.props.data[0]) && !switchBars) {
        this.setState({ switchBars: true })
      }
    }

    if (this.props.data !== prevProps.data) {
    }
  }

  componentDidMount = () => {
    const { switchBars } = this.state

    if (this.props.data) {
      if (!Array.isArray(this.props.data[0]) && switchBars) {
        this.setState({ switchBars: false, level: 0 })
      }

      if (Array.isArray(this.props.data[0]) && !switchBars) {
        this.setState({ switchBars: true, level: 0 })
      }
    }
  }

  handleBarClick = (name, element) => {
    const {
      resultByDivison,
      graphicBarsWatcher,
      idSegment,
      checkboxExclude,
      useSingleCall,
      match: {
        params: { id },
      },
    } = this.props
    const isHistoricalAnalysis = isModuleBySlug(HISTORICAL_ANALYSIS)
    let { level, dataParent, divisionParent, switchBars } = this.state
    const searchLocation = getUrlParams(location.search)
    if (!useSingleCall) {
      this.setState({
        dataParent: { ...dataParent, [level]: this.renderData() },
      })
    }
    
    if(this.state.switchBars && element.id_position){
      graphicBarsWatcher({
        idMeasure: id,
        data: { switchBars: isHistoricalAnalysis ? 1 : 0 },
        id_segment: idSegment,
        first_level: false,
        id_position:element.id_position
      })
    }



    this.setState(
      {
        // dataParent: { ...dataParent, [level]: this.renderData() },
        prevsDivisionParent: [
          ...this.state.prevsDivisionParent,
          element.id_division_parent,
        ],
        divisionParent: element.id_division,
      },
      () => {
        if (useSingleCall) {
          if (resultByDivison) {
            
            graphicBarsWatcher({
              idMeasure: id,
              data: {
                switchBars,
                selectedType: this.props.selectedType,
                id_segment: idSegment,
                isExclude: checkboxExclude,
                id_division_parent: element.id_division,
              },
              params: searchLocation,
              idSegment,
              isExclude: checkboxExclude,
            })
          } else {
            graphicBarsWatcher({
              idMeasure: id,
              data: {
                switchBars,
                id_segment: idSegment,
                isExclude: checkboxExclude,
                id_division_parent: element.id_division,
              },
              params: searchLocation,
              idSegment,
              isExclude: checkboxExclude,
            })
          }
        }
        this.setState({
          level: level + 1,
        })
      }
    )
    if(this.state.switchBars && element.id_position){
      if(this.props.loading){
        this.setState({ [name]: this.props.data });
      }
    } else{
      this.setState({ [name]: element.childs })
    }

  }

  handleBackClick = () => {
    let { dataParent, level, prevsDivisionParent, switchBars } = this.state
    const {
      resultByDivison,
      graphicBarsWatcher,
      idSegment,
      checkboxExclude,
      useSingleCall,
      match: {
        params: { id },
      },
    } = this.props
    const newLevel = level - 1
    const searchLocation = getUrlParams(location.search)
    this.setState(
      {
        subDimensions: level === 0 ? [] : dataParent[newLevel],
        // divisionParent: prevDivisionParent,
      },
      () => {
        let newDivisionsArray = [...prevsDivisionParent]
        let prevDivisionParent = newDivisionsArray.pop()
        if (useSingleCall) {
          if (resultByDivison) {
            graphicBarsWatcher({
              idMeasure: id,
              data: {
                switchBars,
                selectedType: this.props.selectedType,
                id_segment: idSegment,
                isExclude: checkboxExclude,
                id_division_parent: prevDivisionParent,
              },
              params: searchLocation,
              idSegment,
              isExclude: checkboxExclude,
            })
          } else {
            graphicBarsWatcher({
              idMeasure: id,
              data: {
                switchBars,
                id_segment: idSegment,
                isExclude: checkboxExclude,
                id_division_parent: prevDivisionParent,
              },
              params: searchLocation,
              idSegment,
              isExclude: checkboxExclude,
            })
          }
        }
        this.setState({
          level: newLevel <= 0 ? 0 : level - 1,
          prevsDivisionParent: newDivisionsArray,
        })
      }
    )
  }

  renderData = () => {
    const { subDimensions, questions } = this.state
    const { data = [] } = this.props

    if (questions.length) return questions

    if (subDimensions) {
      if (subDimensions.length) return subDimensions
    }

    return data
  }

  render() {
    const {
      location = {},
      history = [],
      loading,
      idSegment,
      checkboxExclude,
    } = this.props
    const { switchBars, dataParent, level } = this.state
    const searchLocation = getUrlParams(location.search)
    const isHistoricalAnalysis = isModuleBySlug(HISTORICAL_ANALYSIS)
    return (
      <div className="multibar-chart">
        <div className="multibar-chart__header">
          <div>
            {this.props.hasDataHistory && isHistoricalAnalysis ? (
              <React.Fragment>
                <Switch
                  checked={switchBars}
                  onChange={(checked) => {
                    const {
                      resultByDivison,
                      match: {
                        params: { id },
                      },
                    } = this.props
                    if (resultByDivison) {
                      this.props.clearFilters()
                      this.props.graphicBarsWatcher({
                        idMeasure: id,
                        data: {
                          switchBars: Number(checked),
                          selectedType: this.props.selectedType,
                          id_segment: idSegment,
                          isExclude: checkboxExclude,
                        },
                        params: searchLocation,
                        idSegment,
                        isExclude: checkboxExclude,
                        first_level: true,
                      })
                    } else {
                      this.props.graphicBarsWatcher({
                        idMeasure: id,
                        data: {
                          switchBars: Number(checked),
                          id_segment: idSegment,
                          isExclude: checkboxExclude,
                        },
                        params: searchLocation,
                        idSegment,
                        isExclude: checkboxExclude,
                        first_level: true,
                      })
                    }

                    this.setState({
                      switchBars: !switchBars,
                      subDimensions: [],
                      questions: [],
                      level: 0,
                    })
                  }}
                />{" "}
                {this.intlmultiBarChart.historicalComparition}
              </React.Fragment>
            ) : (
              <React.Fragment>
                <b style={{ fontSize: "14px" }}>Resultado por dimensión</b>
              </React.Fragment>
            )}
          </div>
          <ul className="multibar-chart__header-legend">
            {map(history, (item, index) => {
              return (
                <li key={index}>
                  <span style={{ backgroundColor: item.color }} />
                  {item.name}
                </li>
              )
            })}
          </ul>
        </div>
        <div className="multibar-chart__body">
          <MultiDrillDown
            loading={loading}
            data={this.renderData()}
            subDimensions={this.state.subDimensions}
            questions={this.state.questions}
            handleBarClick={this.handleBarClick}
            handleBackClick={this.handleBackClick}
            level={this.state.level}
            switchBars={this.state.switchBars}
            calculationType={this.props.calculationType}
          />
        </div>
      </div>
    )
  }
}

MultiBarChart.propTypes = {}

export default MultiBarChart
